import React from 'react';

import { Route, RouteComponentProps, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const AdminToolsMicrofrontend = lazyWithRetry(() => import('./AdminTools'));

const AdminToolsRoutes: React.FC<RouteComponentProps> = (props: RouteComponentProps) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="bulk-updater-mf">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <AdminToolsMicrofrontend />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default AdminToolsRoutes;
